import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Plus } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { CardBodyHeader, CardBodyHeaderTitle } from "@/components/ui/card"
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { ChRecommendedMedicationsSearch } from "@/modules/patients/detail/recommended-medications/ch/ch-recommended-medications-search"
import { RecommendedMedicationList } from "@/modules/patients/detail/recommended-medications/components/recommended-medication-list"
import { DeRecommendedMedicationsSearch } from "@/modules/patients/detail/recommended-medications/de/de-recommended-medications-search"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"
import { useDrawerStore } from "@/stores/useDrawerStore"
import { Language } from "@/types/__generated__/union-types"

const AddRecommendedMedicationButton = () => {
  // Prevent issue when editing recommended medication
  // The new recommended medication will be replaced editing
  const DrawerContent = useDrawerStore((store) => store.DrawerContent)
  return (
    <DropdownMenuTrigger asChild disabled={Boolean(DrawerContent)}>
      <Button data-testid="recommended-medications-open-menu-button" variant="tertiary" className="h-10 w-10 p-2">
        <Plus className="text-on-surface-subdued" />
      </Button>
    </DropdownMenuTrigger>
  )
}

export const RecommendedMedicationsEditableSection = (props: {
  progressNote: ProgressNoteData
  patientLanguage: Language
  diagnosisCode: string
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const country = useCountryParam()

  const handleClose = () => setOpen(false)

  return (
    <>
      <CardBodyHeader data-testid="recommended-medications-title">
        <CardBodyHeaderTitle>{t("episodeOfCare.progressNote.recommendedMedications")}</CardBodyHeaderTitle>
        <div className="pr-2">
          <DropdownMenu open={open} onOpenChange={setOpen}>
            <AddRecommendedMedicationButton />
            <DropdownMenuContent
              align="end"
              className="min-w-75 rounded-lg p-2"
              onCloseAutoFocus={(e) => e.preventDefault()}>
              {country === "CH" ? (
                <ChRecommendedMedicationsSearch
                  {...props}
                  onCloseMenu={handleClose}
                  diagnosisCode={props.diagnosisCode}
                />
              ) : (
                <DeRecommendedMedicationsSearch {...props} onCloseMenu={handleClose} />
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </CardBodyHeader>
      <RecommendedMedicationList progressNote={props.progressNote} patientLanguage={props.patientLanguage} isEditable />
    </>
  )
}
